import { bindActionCreators } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { actions as userActions } from "../slices/auth.slice";
import { actions as chatActions } from "../slices/chat.slice";
import * as paymentSessionActions from "../slices/paymentSession.slice";
import { setEntitlements, clearEntitlements } from "../slices/entitlements.slice";
import {
  hideRestrictionPopup,
  showFeatureRestrictionPopup,
  showResourceRestrictionPopup,
  showFeatureQuotaRestrictionPopup,
  showAiCreditsRestrictionPopup,
} from "../slices/accessControl.slice";
import { useMemo } from "react";

const rootActions = {
  ...userActions,
  ...chatActions,
  ...paymentSessionActions,
  setEntitlements,
  clearEntitlements,
  hideRestrictionPopup,
  showFeatureRestrictionPopup,
  showResourceRestrictionPopup,
  showFeatureQuotaRestrictionPopup,
  showAiCreditsRestrictionPopup,
};
export const useActions = () => {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(rootActions, dispatch), [dispatch]);
};
